// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
import TabController from "./../factories/tab-controller";
import TabPage from "./../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import "./../bindings/bao-tabs";
import "./../bindings/bao-toolbar2";
import "./../bindings/bao-number-box";
import AppTabController from "../services/app-tab-controller";

function ReminderTypeViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.Initialized = ko.observable(false);
    self.IsReadonly = ko.observable(false);
    self.TabViewModel = new TabController(false);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Type())) {
            isComplete = false;
        }
        return isComplete;
    };
    self.BeforeDelete = function () {
        Bao.post("ReminderType/IsReminderTypeInUse", JSON.stringify({
            id: self.OpenData()
        }), function (value) {
            if (value != "true") {
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteReminderType"), "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.Delete();
                    }
                });
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgIsInUse"), "info");
            }
        });
    };
    self.PerformRefresh = function () {
        var def = $.Deferred();
        tabPage.IsLoading(true);
        Bao.post(self.RefreshUrl, JSON.stringify({
            id: self.OpenData()
        }), function (value) {
            tabPage.ObjectId(value.ReminderTypeId);
            ko.map.fromJS(value, self);
            $.when(Bao.post("ReminderType/ResetReminderDefinition", JSON.stringify({
                sessionTabId: tabPage.SessionTabId
            }))).then(function () {
                self.TabViewModel.RefreshTabs().then(function () {
                    tabPage.DirtyFlag(false);
                    tabPage.IsLoading(false);
                    def.resolve();
                });
            });
        });
        return def.promise();
    };
    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post("ReminderType/SaveReminderType", JSON.stringify({
            sessionTabId: tabPage.SessionTabId,
            reminderType: ko.map.toJS(self, true)
        }), function (value) {
            self.SaveTime(value.Result);
            self.PerformRefresh(true);
        });
    };
    self.Delete = function () {
        tabPage.IsLoading(true);
        return Bao.post("ReminderType/DeleteReminderType", JSON.stringify({
            reminderType: self.MinimizeEntity()
        }), function (value) {
            tabPage.IsLoading(false);
            AppTabController.RemoveTab(tabPage);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage != null && tabPage.IsActiveTab != null && tabPage.IsActiveTab() === true) {
            switch (value.ActionKey()) {
                case "ReminderTypeSave":
                    if (self.CompleteCheck() == true) {
                        self.Save();
                    }
                    break;
                case "ReminderTypeRefresh":
                    self.BeforeRefresh();
                    break;
                case "ReminderTypeDelete":
                    self.BeforeDelete();
                    break;
            }
        }
    }));
    var tabPageReminderDefinition = new TabPage();
    tabPageReminderDefinition.AutoSelect = true;
    tabPageReminderDefinition.Url("ReminderType/ReminderDefinitionTab");
    tabPageReminderDefinition.Title = Bao.Session.GetMessage("msgReminderDefinition");
    tabPageReminderDefinition.IsClosable(false);
    tabPageReminderDefinition.ViewModel(new ReminderDefinitionViewModel(tabPageReminderDefinition, self));
    tabPageReminderDefinition.TabLoaded = function () {
        tabPageReminderDefinition.ViewModel().Refresh();
    };
    self.loaded = function () {
        this.InitPaging();
        this.TabPage.DirtyFlag.reset();
        this.TabPage.IsLoading(false);
        this.Focus();
        self.TabViewModel.AddTab(tabPageReminderDefinition);
    };
}
function ReminderDefinitionViewModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.ReminderType = parent;
    self.ReminderDefinitionPageIndex = ko.observable(0);
    self.ReminderDefinitionPageIndex.subscribe(function () {
        self.RefreshReminderDefinitionGrid();
    });
    self.ReminderDefinitionPageSize = ko.observable(10);
    self.ReminderDefinitionTotalRows = ko.observable(0);
    self.ReminderDefinitionSorting = ko.observableArray();
    self.ReminderDefinitionSorting.subscribe(function () {
        self.RefreshReminderDefinitionGrid();
    });
    self.ReminderDefinitionCollection = ko.observableArray([]);
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageReminderDefinition = Bao.Session.GetMessage("msgDeleteReminderDefinition");
    var _allConfigurationItemTypes = Bao.Session.GetMessage("msgAllConfigurationItemTypes");
    var _allCountries = Bao.Session.GetMessage("msgAllCountries");
    var _allStates = Bao.Session.GetMessage("msgAllStates");
    self.SelectedReminderDefinitionRow = ko.observable({});
    self.SelectedReminderDefinitionRow.subscribe(function () {
        self.ToggleReminderDefinitionToolbarButtons();
    });
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddReminderDefinition":
                self.ShowReminderDefinitionDialog(self.ReminderType.ReminderTypeId(), null);
                break;
            case "EditReminderDefinition":
                if (self.SelectedReminderDefinitionRow() != null) {
                    self.ShowReminderDefinitionDialog(self.ReminderType.ReminderTypeId(), self.SelectedReminderDefinitionRow().ReminderDefinitionId);
                }
                break;
            case "DeleteReminderDefinition":
                if (self.SelectedReminderDefinitionRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageReminderDefinition, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteReminderDefinition(self.ReminderType.ReminderTypeId(), self.SelectedReminderDefinitionRow().ReminderDefinitionId);
                        }
                    });
                }
                break;
        }
    };
    self.ToggleReminderDefinitionToolbarButtons = function () {
        ko.utils.arrayForEach(self.ReminderDefinitionToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "DeleteReminderDefinition" || button.ActionKey() == "EditReminderDefinition") {
                button.Enabled(self.SelectedReminderDefinitionRow() != null);
            }
        });
    };
    self.ReminderDefinitionToolbarButtons = ko.observableArray();
    self.ReminderDefinitionToolbarButtons.subscribe(function () {
        self.ToggleReminderDefinitionToolbarButtons();
    });
    self.RefreshReminderDefinitionGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ReminderType/GetReminderDefinitionCollection", JSON.stringify({
            sessionTabId: self.ReminderType.TabPage.SessionTabId,
            reminderTypeId: self.ReminderType.ReminderTypeId(),
            pageIndex: self.ReminderDefinitionPageIndex(),
            pageSize: self.ReminderDefinitionPageSize(),
            sorting: self.ReminderDefinitionSorting()
        }), function (searchResult) {
            self.SelectedReminderDefinitionRow(null);
            self.ReminderDefinitionTotalRows(0);
            self.ReminderDefinitionCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.ReminderDefinitionCollection(searchResult.Models);
                self.ReminderDefinitionTotalRows(searchResult.TotalRows);
                self.ToggleReminderDefinitionToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.AddReminderDefinition = function (model, reminderTypeId) {
        tabPage.IsLoading(true);
        return Bao.post("ReminderType/AddReminderDefinition", JSON.stringify({
            sessionTabId: self.ReminderType.TabPage.SessionTabId,
            reminderDefinitionModel: ko.map.toJS(model),
            reminderTypeId: reminderTypeId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshReminderDefinitionGrid();
        });
    };
    self.DeleteReminderDefinition = function (reminderTypeId, reminderDefinitionId) {
        tabPage.IsLoading(true);
        return Bao.post("ReminderType/DeleteReminderDefinition", JSON.stringify({
            sessionTabId: self.ReminderType.TabPage.SessionTabId,
            reminderTypeId: reminderTypeId,
            reminderDefinitionId: reminderDefinitionId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshReminderDefinitionGrid();
        });
    };
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("600px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                if (self.Dialog.ViewModel().CompleteCheck() == true) {
                    self.AddReminderDefinition(self.Dialog.ViewModel(), self.ReminderType.ReminderTypeId());
                    self.Dialog.Close();
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowReminderDefinitionDialog = function (reminderTypeId, reminderDefinitionId) {
        Bao.post("ReminderType/ShowReminderDefinitionDialog", JSON.stringify({
            sessionTabId: self.ReminderType.TabPage.SessionTabId,
            reminderTypeId: reminderTypeId,
            reminderDefinitionId: reminderDefinitionId
        }), function (value) {
            self.Dialog.ViewModel(ko.map.fromJS(value.Model));
            if (self.Dialog.ViewModel().ConfigurationItemTypeId() == null) {
                self.Dialog.ViewModel().ConfigurationItemTypeName(_allConfigurationItemTypes());
            }
            if (self.Dialog.ViewModel().CountryId() == null) {
                self.Dialog.ViewModel().CountryName(_allCountries());
            }
            if (self.Dialog.ViewModel().StateId() == null) {
                self.Dialog.ViewModel().StateName(_allStates());
            }
            self.Dialog.ViewModel().AllConfigurationItemTypes = ko.observable(self.Dialog.ViewModel().ConfigurationItemTypeId() == null);
            self.Dialog.ViewModel().AllConfigurationItemTypes.subscribe(function () {
                if (self.Dialog.ViewModel().AllConfigurationItemTypes() == true) {
                    self.Dialog.ViewModel().ConfigurationItemTypeId(null);
                    self.Dialog.ViewModel().ConfigurationItemTypeName(_allConfigurationItemTypes());
                }
                else {
                    self.Dialog.ViewModel().ConfigurationItemTypeName("");
                }
            });
            self.Dialog.ViewModel().AllCountries = ko.observable(self.Dialog.ViewModel().CountryId() == null);
            self.Dialog.ViewModel().AllCountries.subscribe(function () {
                if (self.Dialog.ViewModel().AllCountries() == true) {
                    self.Dialog.ViewModel().CountryId(null);
                    self.Dialog.ViewModel().CountryName(_allCountries());
                    self.Dialog.ViewModel().AllStates(true);
                }
                else {
                    self.Dialog.ViewModel().CountryName("");
                }
            });
            self.Dialog.ViewModel().AllStates = ko.observable(self.Dialog.ViewModel().StateId() == null);
            self.Dialog.ViewModel().AllStates.subscribe(function () {
                if (self.Dialog.ViewModel().AllStates() == true) {
                    self.Dialog.ViewModel().StateId(null);
                    self.Dialog.ViewModel().StateName(_allStates());
                }
                else {
                    self.Dialog.ViewModel().StateName("");
                }
            });
            self.Dialog.ViewModel().CountryId.subscribe(function () {
                if (self.Dialog.ViewModel().CountryId() == null) {
                    self.Dialog.ViewModel().StateId(null);
                    self.Dialog.ViewModel().StateName(_allStates());
                }
            });
            self.Dialog.ViewModel().CompleteCheck = function () {
                var isComplete = true;
                if (self.Dialog.ViewModel().AllConfigurationItemTypes() != true) {
                    if (self.Dialog.ViewModel().ConfigurationItemTypeId == null) {
                        isComplete = false;
                    }
                }
                if (self.Dialog.ViewModel().AllCountries() != true) {
                    if (self.Dialog.ViewModel().CountryId == null) {
                        isComplete = false;
                    }
                }
                if (self.Dialog.ViewModel().AllStates() != true) {
                    if (self.Dialog.ViewModel().StateId == null) {
                        isComplete = false;
                    }
                }
                if (self.Dialog.ViewModel().ReminderInterval() == null) {
                    isComplete = false;
                }
                if (self.Dialog.ViewModel().TimeUnitId() == null) {
                    isComplete = false;
                }
                if (isComplete == false) {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
                return isComplete;
            };
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("ReminderType/ResetReminderDefinition", JSON.stringify({
            sessionTabId: self.ReminderType.TabPage.SessionTabId
        }), function () {
            self.RefreshReminderDefinitionGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
}
;
Bao.inherit(ReminderTypeViewModel, SearchPaging);
ReminderTypeViewModel.prototype.RefreshUrl = "ReminderType/GetReminderType";
ReminderTypeViewModel.prototype.PrimaryKey = "ReminderTypeId";
ReminderTypeViewModel.prototype.PermissionForward = "ReminderTypeMoveForwardSearch";
ReminderTypeViewModel.prototype.PermissionBackward = "ReminderTypeMoveBackwardSearch";
export default ReminderTypeViewModel;